import { skipToken } from "@reduxjs/toolkit/query";

import { CsComponent } from "api/memberPortal/cscomponent/cscomponent.types";
import { useGetCsComponentProjByPidQuery } from "api/memberPortal/cscomponent/cscomponentproj/cscomponentproj.api";
import { useGetEarsAndFilesByProductIdQuery } from "api/memberPortal/ear/ear.api";
import { EarWithFiles } from "api/memberPortal/ear/ear.types";
import { useGetProductFeaturesQuery } from "api/memberPortal/features/productFeatures/productFeatures.api";
import { ProductFeature } from "api/memberPortal/features/productFeatures/productFeatures.types";
import { useGetFilesByTypeAndIdQuery } from "api/memberPortal/files/files.api";
import { UserUploadedFile } from "api/memberPortal/files/files.types";
import { useGetLabVendorsQuery } from "api/memberPortal/orgs/orgs.api";
import { Organization } from "api/memberPortal/orgs/orgs.types";
import { useGetAllProductEvaluatorsQuery } from "api/memberPortal/project/personnel/personnel.api";
import { ProjectPersonnel } from "api/memberPortal/project/personnel/personnel.types";
import { useGetProductQuery } from "api/memberPortal/project/product/product.api";
import { Product } from "api/memberPortal/project/product/product.types";
import { ProjectPp } from "api/memberPortal/project/protectionProfiles/protectionProfile.types";
import { useGetAllProjectPpByProductIdQuery } from "api/memberPortal/project/protectionProfiles/protectionProfiles.api";

const PRODUCT = {} as Product;
const PRODUCT_FILES = [] as UserUploadedFile[];
const PRODUCT_PPS = [] as ProjectPp[];
const EAR_DATA = [] as EarWithFiles[];
const CS_COMPONENTS = [] as CsComponent[];
const EVALUATORS = [] as ProjectPersonnel[];
const LAB_VENDORS = [] as Organization[];
const PRODUCT_FEATURES = [] as ProductFeature[];

export const useProductFormData = (product_id?: number) => {
  const { data: product = PRODUCT, isFetching: isFetchingProduct } =
    useGetProductQuery(product_id ?? skipToken, {
      refetchOnMountOrArgChange: true,
    });

  const { data: productFiles = PRODUCT_FILES, isFetching: isFetchingFiles } =
    useGetFilesByTypeAndIdQuery(
      product_id
        ? {
            file_type: "product",
            file_type_id: product_id,
          }
        : skipToken,
      {
        skip: !product_id,
        refetchOnMountOrArgChange: true,
      },
    );

  const { data: productPps = PRODUCT_PPS, isFetching: isFetchingProjectPps } =
    useGetAllProjectPpByProductIdQuery(product_id ?? skipToken, {
      refetchOnMountOrArgChange: true,
    });

  const { data: earData = EAR_DATA, isFetching: isFetchingEarsAndFiles } =
    useGetEarsAndFilesByProductIdQuery(product_id ?? skipToken, {
      refetchOnMountOrArgChange: true,
    });

  const {
    data: csComponents = CS_COMPONENTS,
    isFetching: isFetchingCsComponent,
  } = useGetCsComponentProjByPidQuery(product_id ?? skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const {
    data: evaluators = EVALUATORS,
    isFetching: isFetchingProductEvaluator,
  } = useGetAllProductEvaluatorsQuery(product_id ?? skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const { data: labVendors = LAB_VENDORS, isFetching: isFetchingLabVendors } =
    useGetLabVendorsQuery();

  const {
    data: productFeatures = PRODUCT_FEATURES,
    isFetching: isFetchingProductFeatures,
  } = useGetProductFeaturesQuery(product_id ? { product_id } : skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const isLoading =
    isFetchingProduct ||
    isFetchingFiles ||
    isFetchingProjectPps ||
    isFetchingEarsAndFiles ||
    isFetchingCsComponent ||
    isFetchingProductEvaluator ||
    isFetchingLabVendors ||
    isFetchingProductFeatures;

  return {
    product,
    productFiles,
    productPps,
    earData,
    csComponents,
    evaluators,
    labVendors,
    productFeatures,
    isLoading,
  };
};
